//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { PrimaryRouteAnchor } from '@components/RouteAnchor';
import { PrimaryAnchor } from '@components/atoms/anchor/Anchor';
import { BodyText, SubsectionText } from '@components/atoms/text/Text';
import {
  CONFIGURE_CATALOG_LINK,
  UiaProductTrackingIds,
} from '@uia/products/constants/UiaProductConstants';

interface NoCatalogProps {
  isEcommerceIntegrationEnabled: boolean;
}

export const NoCatalog = ({
  isEcommerceIntegrationEnabled,
}: NoCatalogProps) => {
  return (
    <NoCatalogContainer>
      <SubsectionText>Your product catalog isn’t connected</SubsectionText>
      <BodyText>
        Bazaarvoice uses catalog data like price, category, and availability to
        turn discovery into commerce from your touch points.
      </BodyText>
      <BodyText>
        {isEcommerceIntegrationEnabled ? (
          <PrimaryRouteAnchor
            rel='noreferrer'
            state='account-settings.ecommerceSetup'
            target='_blank'
            trackingId={UiaProductTrackingIds.CONNECT_CATALOG_LINK}
          >
            Connect your product catalog
          </PrimaryRouteAnchor>
        ) : (
          <PrimaryAnchor
            href={CONFIGURE_CATALOG_LINK}
            rel='noreferrer'
            target='_blank'
            trackingId={UiaProductTrackingIds.CONNECT_CATALOG_LINK}
          >
            Connect your product catalog
          </PrimaryAnchor>
        )}{' '}
        so we can help you monetize your media at scale, boost discoverability,
        and increase conversions.
      </BodyText>
      <BodyText>
        Alternatively, you can also tag a product by entering a URL above.
      </BodyText>
    </NoCatalogContainer>
  );
};

const NoCatalogContainer = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings[2]};
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: ${theme.spacings[3]};
    background-color: ${theme.colors.gray00};
  `,
);
